export class ErrorResponseWrapper<T = string[]> extends Error {
  readonly response: Response;
  readonly ERROR = "ERROR";
  /* TTRQ-43650 custom start */
  readonly BAD_REQUEST_ERROR_CODE = 400;
  readonly NOT_FOUND_ERROR_CODE = 404;
  /* TTRQ-43650 custom end */

  constructor(response: Response) {
    super();
    this.response = response;
  }

  async getErrorMessages(): Promise<T> {
    return new Promise<T>((resolve) => {
      this.response
        .json()
        .then((msg: T) => {
          typeof msg === "string" ? resolve([msg] as any) : resolve(msg);
        })
        .catch(() => {
          if (!this.response.ok) {
            const errorMessageFromServer = {
              message: this.response.status + " " + this.response.statusText,
            };
            resolve([errorMessageFromServer] as any);
          } else {
            resolve([] as any);
          }
        });
    });
  }

  /* TTRQ-32365 custom start: get error message from response */
  async getTTErrorMessages(): Promise<{
    message: string;
    isBadRequestError?: boolean;
    isNotFoundError?: boolean;
    responseJSON?: { [key: string]: any };
  }> {
    try {
      const result = await this.response.json();
      return {
        message:
          result.message?.type === this.ERROR ? result.message?.text : "",
        isBadRequestError: this.response.status === this.BAD_REQUEST_ERROR_CODE,
        isNotFoundError: this.response.status === this.NOT_FOUND_ERROR_CODE,
        responseJSON: result,
      };
    } catch (e) {
      const { status, statusText } = this.response;
      return {
        message: `${status} ${statusText}`,
      };
    }
  }
  /* TTRQ-32365 custom end */
}
